'use strict';

import '../css/common.scss';
 

(function (window, document, $) {
    // $(function () {
    //タブ切り替え
    $(function () {
        const e = document.getElementById("panel")
            , t = document.querySelectorAll("[data-panel-btn]")
            , t2 = document.querySelectorAll("[data-panel-btn2]");
        Array.from(t).forEach((t => {
            const i = t.getAttribute("data-panel-btn")
                , btn2 = document.querySelector(`[data-panel-btn2="${i}"]`)
                , n = document.querySelector(`[data-panel="${i}"]`);
            t.addEventListener("click", (() => {
                const i = e.querySelectorAll(".is-active");
                Array.from(i).forEach((e => {
                    e.classList.remove("is-active")
                }
                )),
                    t.classList.add("is-active"),
                    btn2.classList.add("is-active"),
                    n.classList.add("is-active")
            }
            ))
        }
        )),   
        Array.from(t2).forEach((t2 => {
            const i = t2.getAttribute("data-panel-btn2")
                , btn1 = document.querySelector(`[data-panel-btn="${i}"]`)
                , n = document.querySelector(`[data-panel="${i}"]`);
            t2.addEventListener("click", (() => {
                const i = e.querySelectorAll(".is-active");
                Array.from(i).forEach((e => {
                    e.classList.remove("is-active")
                }
                )),
                    t2.classList.add("is-active"),
                    btn1.classList.add("is-active"),
                    n.classList.add("is-active")
            }
            ))
        }
        ))
    });
    window.addEventListener('DOMContentLoaded', (event) => {
        // drawer();
        // scrollToTopLink();
       

        const bodyClassList = document.body.classList;

        //faq toggle
        $(".js-accordion").on('click touchend', function (event) {
            event.preventDefault();
            $(this).parents(".faq_wrap").toggleClass("open");
        });

        // smoothscroll
        var scroll = new SmoothScroll('a[href*="#top"]');
        var scroll2 = new SmoothScroll('a[href*="#LESSON"]');

        //モーダル表示
        if ($(".js-modal-target").length > 0) {
            $(".js-modal-target").modaal({
                // hide_close: false, // 閉じるボタンの表示・非表示の制御する
                width: "auto",
                custom_class: 'js-modal',
                overlay_opacity: 0, // 背景オーバーレイの透明度を設定
                // overlay_close: false, // 背景オーバーレイをクリックしてモーダルが閉じるかどうかの制御
                animation_speed: 250, // トリガーをクリックしてから、モーダルが表示されるまでのスピード
                background_scroll: false, // モーダルを開いている間、背景をスクロールできるかどうか 
            }
            );
        }
        
        $('.js-modal-close').on('click', function () {
            // モーダルを閉じる
            // $('.js-modal-target').modaal('close');
        });

        //Swiper

        let secCaseSwiper = null;
        const mediaQuery = window.matchMedia('(max-width: 767px)');

        const checkBreakpoint = (e) => {
            if (e.matches) {
                initSwiper();
            } else if (secCaseSwiper) {
                secCaseSwiper.destroy(false, true);
            } 
        }

        const initSwiper = () => {
            // .card02
            secCaseSwiper = new Swiper('.case_contents .swiper', {
                slidesPerView: 'auto',
                spaceBetween: 28,
                grabCursor: true,
                // loop: true,
                // loopAdditionalSlides: 1,
                pagination: {
                    el: '.case_contents .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.case_contents .swiper .swiper-button-next',
                    prevEl: '.case_contents .swiper .swiper-button-prev',
                },
               
            });
        };

        mediaQuery.addEventListener('change', checkBreakpoint);
        checkBreakpoint(mediaQuery);

    });
})(window, document, jQuery);